function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M1.9 13.078L.163 3.538c2.5.684 5.126.627 7.877-.171 2.751-.799 4.645-1.892 5.683-3.28l6.529 9.025L1.9 13.078z",
  id: "prepared_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.037 2.402l2.905 10.79c2.49.892 5.173 1.115 8.05.67 2.877-.446 4.727-1.666 5.551-3.66V.018L.037 2.402z",
  id: "prepared_svg__d"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-35.3%",
  y: "-121.4%",
  width: "170.5%",
  height: "342.7%",
  filterUnits: "objectBoundingBox",
  id: "prepared_svg__a"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "4.50803571 0",
  in: "SourceGraphic"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-617-247H823V823H-617z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 3h70v60H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.796 35.385c-.941.214-1.411.522-1.411.922 0 .6 1.04 1.023 2.596 1.558 1.557.535 6.366 1.962 7.088 2.473.722.511 6.273 3.181 9.313 3.484 3.04.304 14.275.607 15.878.304 1.068-.202 2.232-1.08 3.49-2.634l-19.732-8.384-17.222 2.277z",
  fill: "#D8D8D8",
  filter: "url(#prepared_svg__a)",
  transform: "translate(8 10)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.067 38.351c1.285-2.429 2.388-6.4 4.732-7.193 2.345-.792 5.294-1.366 7.858-1.82 2.563-.455 3.812 0 5.802 0 1.99 0 4.77-.667 8.664 0 3.895.665 2.915 1.65 4.259 2.387 1.344.737 5.227.62 7.254 2.38 2.026 1.76.246 3.551 1.417 5.153 1.171 1.602 1.546 2.72 0 4.851s-2.66 3.785-7.442 6.766c-4.783 2.98-14.259 2.174-21.585.647-7.327-1.528-6.48-2.429-10.513-3.83-4.033-1.4-8.59-3.05-8.59-5.12 0-1.417 2.158-.504 3.252-1.034 2.03-.983 4.214-1.905 4.892-3.187z",
  stroke: "#944A24",
  fill: "#FFCD78"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.312 39.12a7.27 7.27 0 01-1.616 1.18c-.596.321-1.38.758-2.35 1.31.86.827 3.32 1.141 7.378.943 6.088-.297 7.813-.72 8.476.862.662 1.582 4.898 3.532 7.409 3.532 2.51 0 6.09-1.677 7.66-.838 1.57.838 4.453 1.087 6.254.838 1.2-.166 2.857-.732 4.97-1.697l1.47-2.099-1.47-.886.56-4.427c.323-1.662-.055-2.818-1.133-3.466-1.607-1.219-4.71-1.288-6.416-2.025-1.706-.736-1.261-1.444-2.235-1.843-.974-.398-2.9-.8-5.835.276-2.934 1.076-7.114 2.7-8.803 2.075-1.69-.624-6.63-.815-8.492.624-1.24.96-3.183 2.84-5.827 5.64z",
  fill: "#EDB46D"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.77 28.838)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.724 15.388L3.516 9.513C1.568 9.469 0 7.357 0 4.757 0 2.13 1.601 0 3.577 0c.336 0 .662.062.97.177L39.505 5.95c1.902.11 3.42 2.196 3.42 4.753 0 2.62-1.593 4.744-3.56 4.756l-.033.03-.261-.044a2.742 2.742 0 01-.346-.057z",
  stroke: "#944A24",
  fill: "#F6E7B5"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#944A24",
  fill: "#F6E7B5",
  cx: 39.346,
  cy: 10.703,
  rx: 3.577,
  ry: 4.757
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.272 12.228c-.213.493-.546.853-.926.853-.658 0-1.21-1.081-1.21-2.066 0-.985.552-2.066 1.21-2.066.353 0 .665.31.88.75l2.727.268c.689-.724 1.538-1.015 2.55-.873 2.318.326 3.376 1.88 3.237 2.868-.139.987-1.505 2.2-3.902 1.863-.856-.12-1.588-.558-2.194-1.312l-2.372-.285z",
  stroke: "#944A24",
  fill: "#F6E7B5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.962 10.673c0-2.07 1.145-3.538 2.792-3.538",
  stroke: "#FEFDF7",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(48.346 21.703)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prepared_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prepared_svg__b"
})), /*#__PURE__*/React.createElement("path", {
  d: "M6.924 7.69c3.685 0 7.006-2.989 7.006-6.325 0-3.337-3.32-5.76-7.006-5.76C3.238-4.394.199-1.797.199 1.54s3.04 6.15 6.725 6.15z",
  stroke: "#944A24",
  fill: "#E72B2B",
  mask: "url(#prepared_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.593 5.393c3.681 1.081 6.268.573 7.76-1.525 1.493-2.098 2.186-4.097 2.08-5.996 1.733 3.44.987 6.247-2.239 8.422-2.826 1.29-5.36.99-7.6-.901z",
  fill: "#C31616",
  mask: "url(#prepared_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.637-4.471c-.593-.319-1.218-.319-1.876 0-.658.319-.987.75-.987 1.296.843-.483 1.477-.604 1.903-.362.425.241.745.362.96.362-.215.282-.215.654 0 1.115.215.462.497.692.845.692.473-.457.71-.873.71-1.247 0-.373-.237-.829-.71-1.367 1.079-.538 1.618-.538 1.618 0s.48.686 1.438.445a4.37 4.37 0 00-.89-1.335c-.365-.37-1.087-.37-2.166 0v-1.406h-.845v1.807z",
  stroke: "#503117",
  strokeWidth: 1.2,
  fill: "#92C28F",
  mask: "url(#prepared_svg__c)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M49.145 25.755c.345.836 4.93 1.037 8.406 0 3.478-1.038 4.755-2.11 4.755-3 0-.891-2.47-1.33-6.57-.35-4.1.98-6.936 2.514-6.591 3.35z",
  stroke: "#944A24",
  fill: "#FF5C5C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.183 40.73c.329 0 .298-.266.298-.595 0-.328.03-.594-.298-.594-.33 0-.298.266-.298.594 0 .329-.032.595.298.595z",
  stroke: "#FFF",
  strokeWidth: 1.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.604 34.932l34.232 5.81 1.239 2.64-33.517-5.804c-.274-.107-.654-.412-1.14-.915-.485-.504-.757-1.08-.814-1.73z",
  fill: "#EED290"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.174 42.751c.5.512 1.133 1.057 1.901 1.635 1.153.869 6.041 1.98 7.419 2.825 1.378.844 3.749 1.938 8.081 3.068 2.888.753 6.726 1.233 11.513 1.439",
  stroke: "#FFF5E3",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.61 33.083l29.437 5.215",
  stroke: "#FFF",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(12 -38.898 133.082)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prepared_svg__e",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prepared_svg__d"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#prepared_svg__e)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.338 1.428)"
}, /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#944A24",
  fill: "#E72B2B",
  cx: 6.399,
  cy: 10.129,
  rx: 6.399,
  ry: 5.751
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.36 13.278c2.74.853 5.137.439 7.19-1.241 2.052-1.68 2.554-3.634 1.505-5.86.623.4 1.086.883 1.39 1.45 1.252 2.335 1.205 4.68-1.33 6.838-3.236 1.781-6.154 1.385-8.755-1.187z",
  fill: "#C31616"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.614 3.223c-.245.332-.914.007-2.218.634C.092 4.484-.23 5.38.35 5.797c.58.416 1.9-.649 2.52-.535.62.115.904-.196 1.33.712.426.907-.874 1.428.136 2.065 1.009.637 1.946-1.013 1.946-1.748 0-.735-.163-1.704.688-1.351.85.352 2.153.317 2.402-.234.25-.55.004-1.153-1.028-1.42-1.032-.265-2.19.208-2.513-.37-.323-.576-.243-1.14-.383-1.795-.14-.656-1.61-.44-1.887.01-.277.449.297 1.76.053 2.092z",
  stroke: "#944A24",
  fill: "#4FB648"
})))), /*#__PURE__*/React.createElement("path", {
  d: "M27.613 24.68c1.713 1.422 3.885 2.147 6.515 2.176 2.63.028 4.655-.813 6.076-2.524",
  stroke: "#944A24",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgPrepared(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 70 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default SvgPrepared;